import { setValidation } from '1.newComponents/form/validationSlice'
import {
  DUE_DATE,
  VENDOR,
  DEPARTMENT,
  PARTICULARS,
  PROJECT,
  SUB_PROJECT,
  RELEASING_CENTER,
  SUPPORTING_DOCUMENTS,
  PROJECT_CLASSES,
  REQUEST_TYPE,
  GROSS_PRICE_PER_ITEM
} from 'types'

// the validations for each fields
const isNull = e => {
  const value = e.target.value
  if (!value) {
    return [true, 'This field is required']
  } else {
    return [false, '']
  }
}
export const VALIDATIONS = {
  [DUE_DATE]: e => {
    return isNull(e)
  },
  [VENDOR]: (e, options = []) => {
    if (isNull(e)[0] === false) {
      if (!options.includes(e.target.value)) {
        return [true, 'Invalid vendor name']
      } else {
        return [false, '']
      }
    } else {
      return isNull(e)
    }
  },
  [DEPARTMENT]: e => {
    return isNull(e)
  },
  [PARTICULARS]: e => {
    return isNull(e)
  },
  [PROJECT]: (e, options = []) => {
    if (isNull(e)[0] === false) {
      if (!options.includes(e.target.value)) {
        return [true, 'Invalid project name']
      } else {
        return [false, '']
      }
    } else {
      return isNull(e)
    }
  },
  [SUB_PROJECT]: e => {
    return [false, '']
  },
  [GROSS_PRICE_PER_ITEM]: e => {
    if (isNull(e)[0] === false) {
      if (isNaN(e.target.value)) {
        return [true, 'Invalid number']
      }
      if (e.target.value < 0) {
        return [true, 'Amount must be greater than zero']
      }
      return [false, '']
    } else {
      return isNull(e)
    }
  },
  [RELEASING_CENTER]: e => {
    return isNull(e)
  },
  [SUPPORTING_DOCUMENTS]: e => {
    const file = e.target.files[0]
    if (file) {
      if (file.type === 'application/pdf') {
        return [false, '']
      } else {
        return [true, 'Invalid file type']
      }
    } else {
      return [true, 'This is required']
    }
  }
}

export default function (validations, dispatch) {
    
  let result = false
  for (const key in validations) {
    const isError = validations[key][0]
    if (isError === '') {
      dispatch(
        setValidation({
          fieldName: key,
          error: true,
          message: 'This is required'
        })
      )
      result = true
      break
    }
    if (isError) {
      result = true
      break
    }
  }
  return result
}
